module.exports = __webpack_public_path__ + "static/media/arrow-forward.66bdaa19.svg";